import {
	createSlice,
	PayloadAction,
} from '@reduxjs/toolkit';
import {
	CompanyEstablishment,
	CompanyEstablishmentsState,
} from '@localTypes/companyEstablishment';

const initialState: CompanyEstablishmentsState = {};

export const companyEstablishmentsSlice = createSlice({
	initialState,
	name: 'company_establishments',
	reducers: {
		clearAllCompanyEstablishments: () => ({}),
		clearCompanyEstablishments: (state, action: PayloadAction<number>) => {
			const companyId = action.payload;
			delete state[companyId];
		},
		setCompanyEstablishments: (state, action: PayloadAction<{
			companyId: number;
			result: CompanyEstablishment[];
			total: number;
		}>) => {
			const {
				companyId,
				result,
				total,
			} = action.payload;
			state[companyId] = {
				isError: false,
				isLoading: false,
				result,
				total,
			};
		},
		setCompanyEstablishmentsError: (state, action: PayloadAction<{
			companyId: number;
			isError: boolean;
		}>) => {
			const {
				companyId,
				isError,
			} = action.payload;
			if (!state[companyId]) {
				state[companyId] = {
					isError: false,
					isLoading: false,
					result: [],
					total: 0,
				};
			}
			state[companyId].isError = isError;
		},
		setCompanyEstablishmentsLoading: (state, action: PayloadAction<{
			companyId: number;
			isLoading: boolean;
		}>) => {
			const {
				companyId,
				isLoading,
			} = action.payload;
			if (!state[companyId]) {
				state[companyId] = {
					isError: false,
					isLoading: false,
					result: [],
					total: 0,
				};
			}
			state[companyId].isLoading = isLoading;
		},
	},
});

export const {
	clearAllCompanyEstablishments,
	clearCompanyEstablishments,
	setCompanyEstablishments,
	setCompanyEstablishmentsError,
	setCompanyEstablishmentsLoading,
} = companyEstablishmentsSlice.actions;

export const companyEstablishmentsReducer = companyEstablishmentsSlice.reducer;
